import { render, staticRenderFns } from "./PptPreviewDialog.vue?vue&type=template&id=661df9f8&scoped=true"
import script from "./PptPreviewDialog.vue?vue&type=script&lang=js"
export * from "./PptPreviewDialog.vue?vue&type=script&lang=js"
import style0 from "./PptPreviewDialog.vue?vue&type=style&index=0&id=661df9f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661df9f8",
  null
  
)

export default component.exports